import { useEffect, useState } from "react";
import { LayoutGrid } from "lucide-react";
import api from "../lib/api";
import NotionBoard from "./NotionBoard";

export default function LocationBoards({ location }) {
  const [boards, setBoards] = useState([]);
  const [boardId, setBoardId] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/notion/location-boards");
        const bs = data.boards || [];
        setBoards(bs);
        if (bs.length) {
          const preferred = bs.find((b) => b.title === "Tasks") || bs[0];
          setBoardId(preferred.id);
        }
      } catch { /* notion optional */ }
      finally { setReady(true); }
    })();
  }, []);

  if (!ready) return <div className="h-24 rounded-lg bg-brand-surface border border-brand-border animate-pulse" />;
  if (!boards.length) return <div className="text-sm text-brand-muted" data-testid="loc-boards-empty">No location-linked Notion boards available.</div>;

  return (
    <div data-testid="loc-boards">
      <div className="mb-4 relative inline-block">
        <LayoutGrid className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-tertiary" />
        <select value={boardId} onChange={(e) => setBoardId(e.target.value)} data-testid="loc-board-select"
          className="pl-9 pr-8 py-2 text-sm border border-brand-border rounded-lg bg-brand-surface text-brand-ink min-w-[200px]">
          {boards.map((b) => <option key={b.id} value={b.id}>{b.title}</option>)}
        </select>
      </div>
      {boardId && <NotionBoard boardId={boardId} location={location} />}
    </div>
  );
}
